import { navigateAddModal } from "./navigation";
import { IThunkDispatch, RootState } from "../store";
import { ICtc } from "../interfaces/CtcInterface";

export enum Type {
  PUT_RESOURCECENTRSERVICEPROVIDER = "PUT_RESOURCECENTRSERVICEPROVIDER"
}

export const showServiceProviderInfoModal =
  (serviceProviderId: number) =>
  async (dispatch: IThunkDispatch): Promise<void> => {
    dispatch(
      navigateAddModal({
        component: "ServiceProviderShow",
        props: {
          serviceProviderId
        }
      })
    );
  };

// Update service provider's activeCtc in state.resources
export const updateServiceProviderWithCtc =
  (spId: number, ctcData: ICtc | null) =>
  async (dispatch: IThunkDispatch, getState: () => RootState): Promise<void> => {
    const state = getState();

    const serviceProvider = state.resources.resourceCentreServiceProviders.find(
      (sp) => sp.id === spId
    );

    if (!serviceProvider) return;

    const updatedserviceProvider = { ...serviceProvider, activeCtc: ctcData };

    dispatch({
      type: Type.PUT_RESOURCECENTRSERVICEPROVIDER,
      payload: updatedserviceProvider
    });
  };
